<template>
  <div class="Table">
    <div class="Table__header">
      <div class="Table__tr">
        <div class="Table__th" style="flex:1">序号</div>
        <div class="Table__th" style="flex:3">时间</div>
        <div class="Table__th" style="flex:2">电池编号</div>
        <div class="Table__th" style="flex:2">所属组</div>
        <div class="Table__th" style="flex:2">报警类型</div>
      </div>
    </div>
    <div
      v-show="!tableData.length"
      class="empty"
    >暂无数据</div>
    <div class="Table__body">
      <div class="Table__scroll">
        <div
          v-for="(item, index) in tableData"
          :key="index"
          class="Table__tr"
          :class="`Table__tr_${arr[Math.floor(Math.random() * 3)]}`"
          :ref="`tr_${index}`"
        >
          <div class="Table__td" style="flex:1">{{index + 1}}</div>
          <div class="Table__td" style="flex:3">{{item.timeBegin}}</div>
          <div class="Table__td" style="flex:2">{{item.bmsNo}}</div>
          <div class="Table__td" style="flex:2">{{item.organizationName}}</div>
          <div class="Table__td" style="flex:2">{{item.type}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      arr: ["red", "yellow", "blue"],
      alarmTypeArr: [
        "high pressure",
        "Low pressure",
        "high temperature",
        "Over discharge",
        "abnormal"
      ],
      tableData: new Array(0),
      activeIndex: 0
    };
  },
  computed: {
    ...mapState(["TOKEN"]),
  },
  created() {},
  mounted() {
    if (this.TOKEN===null) return;
    this.getAlarms();
    // this.initCarousel();
  },
  watch: {
    TOKEN(val) {
      if (val != null) {
        this.getAlarms();
      }
    },
    tableData() {
      if (
        this.$refs[`tr_${this.activeIndex}`] &&
        this.$refs[`tr_${this.activeIndex}`][0]
      ) {
        const dom = this.$refs[`tr_${this.activeIndex}`][0];
        if (dom) {
          dom.scrollIntoView();
        }
      }
      this.activeIndex++;
      this.activeIndex === this.tableData.length && (this.activeIndex = 0);
    }
  },
  methods: {
    async getAlarms() {
      try {
        const { data } = await this.$API.getAlarms({
          num: 200
        });
        this.tableData = data || [0];
      } catch (error) {
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      }
    },
    //初始化轮播
    initCarousel() {
      setInterval(() => {
        this.getAlarms();
      }, 6000 * 10);
    }
  }
};
</script>

<style lang="scss" scoped>
.Table {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  &__body {
    @include scrollBar();
    flex: 1;
    overflow-y: auto;
  }

  &__tr {
    display: flex;
    height: 33px;
    line-height: 33px;
    font-size:14px;
    font-family:Microsoft YaHei;
    color:#fff;

    // &:nth-child(2n) {
    //   background: rgba(37, 38, 42, 1);
    // }
    
    // &_red {
    //   color: rgba(232, 24, 24, 1);
    // }

    // &_yellow {
    //   color: rgba(240, 152, 26, 1);
    // }

    // &_blue {
    //   color: rgba(31, 138, 248, 1);
    // }
  }

  &__th {
    flex: 1;
    text-align: center;
    font-size:14px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(12,160,141,1);
  }

  &__td {
    flex: 1;
    text-align: center;
  }
}
.empty {
  text-align: center;
  position: relative;
  top: 30%;
  color: rgb(146, 146, 146);
}
</style>
